// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.productimporteditor', {
        url: '/productimporteditor/{importFileId}',
        views: {'wideColumnView@product': {
            templateUrl: 'main/product/productimporteditor/productimporteditor.tpl.html',
            controller: 'ProductImportEditorController as vm'
        }},
        resolve: {
            importFile: importFileResolver,
            defaultCurrency: defaultCurrencyResolver,
            locations: locationsResolver,
            currencies: currenciesResolver
        }
    });
}

// @ngInject
function importFileResolver($stateParams, FileDataImportApiServiceV2) {
    return FileDataImportApiServiceV2.getImportFile($stateParams.importFileId);
}

// @ngInject
function defaultCurrencyResolver(FileDataImportApiServiceV2) {
    return FileDataImportApiServiceV2.getCurrencyDefault();
}

// @ngInject
function locationsResolver(FileDataImportApiServiceV2) {
    return FileDataImportApiServiceV2.getLocations();
}

// @ngInject
function currenciesResolver(FileDataImportApiServiceV2) {
    return FileDataImportApiServiceV2.getCurrencies();
}

// @ngInject
function ProductImportEditorController($scope, importFile, FileDataImportApiServiceV2, ToasterService, loadSpinnerService, 
    confirmationDialogService, informationDialogService, connectVitalArticleInformationDialogService, $translate, $state, defaultCurrency, $q, locations, FeatureSwitchService,
    importFinalizationDialogService, currencies) {
    var vm = this;
    var criticalSeverityLevels = ['error'];

    //Properties
    vm.importFile = importFile;
    vm.validationErrors = [];
    vm.dataCheckResults = [];
    vm.selectedFileRowIds = [];
    vm.importUpdateCount = 0;
    vm.defaultCurrency = defaultCurrency;
    vm.selectedDisplayMessage = '';
    vm.validationErrorChangeCount = 0;
    vm.locations = locations;
    vm.selectedLocation = {};
    vm.showAdvancedFunctionsPanel = false;
    vm.hasAdvancedImportModule = FeatureSwitchService.hasAdvancedImport();
    vm.currencies = currencies;
    vm.importGridComponent = {};
    vm.doneAutoConnectArticleDataCheck = false;

    //Methods
    vm.selectFileRows = selectFileRows;
    vm.resetSelectedImportRows = resetSelectedImportRows;
    vm.isAllowedToFinalize = isAllowedToFinalize;
    vm.isAllowedToSave = isAllowedToSave;
    vm.saveImportFile = saveImportFile;
    vm.shouldShowValidationErrorsPanel = shouldShowValidationErrorsPanel;
    vm.finalizeImportFile = finalizeImportFile;
    vm.showFinalizeDialog = showFinalizeDialog;
    vm.updateImportSummary = updateImportSummary;
    vm.checkForConnectionWithArticleData = checkForConnectionWithArticleData;
    vm.getMissingSiblingRows = getMissingSiblingRows;
    vm.getPdfLabels = getPdfLabels;
    vm.registerImportGridComponent = registerImportGridComponent;
    vm.removeIncorrectCharactersFromBarcodes = removeIncorrectCharactersFromBarcodes
    vm.returnToList = returnToList
    
    // Methonds on child components (only available after component initialization)
    var cleanBarcodes = function(){}; // Will hold the function from importrowsgrid.component.js once its initialized

    activate();

    function activate() {
        setAllRowsPristine();

        $scope.$watch(function() { return vm.dataCheckResults.length; }, function(oldValue, newValue) {
            if(oldValue !== newValue && !vm.doneAutoConnectArticleDataCheck && !vm.importFile.autoConnectToProductInfoDisabled){
                setTimeout(() => {
                    checkForConnectionWithArticleData(true);
                    vm.doneAutoConnectArticleDataCheck = true;
                }, 500)
            }
        });
    }

    function showColumn(list, maxResults, field1, field2) {
        var columnVisible = false;
        for (let i = 0; i < Math.min(list.length, maxResults); i++) {
            const element = list[i];
            if (element[field1] !== element[field2]) { columnVisible = true; }
        }
        return columnVisible;
    }

    function returnToList(){
        $state.go('product.productimport', { type: 'existingImportFile' }, { reload:true})
    }

    function removeIncorrectCharactersFromBarcodes() {
        confirmationDialogService.showDialog($translate.instant("import.cleanbarcodesconfirmation")).then(function (result) {
            if (result === true) {
                cleanBarcodes();
            }
        });
    }

    function registerImportGridComponent(component) {
        cleanBarcodes = component.cleanBarcodes;
    }

    function checkForConnectionWithArticleData(isAutoRun = false) {

        var request = {
            importFileId: vm.importFile.id
        };
        
        loadSpinnerService.start('mainSpinner');
        FileDataImportApiServiceV2.checkForConnectionWithArticleData(request).then(function(response) {
            if (response.vitalChanges && response.vitalChanges.length > 0) {
                connectVitalArticleInformationDialogService.showDialog(response.vitalChanges, isAutoRun).then(function (result) {
                    if (result.approved === true) {
                        connectWithArticleData();
                    }
                    if (result.disable === true){
                        disableAutoArticleData();
                    }
                });

            } else {
                ToasterService.showSuccess($translate.instant('productimport.foundNoChangesToArticleData'));
            }
        }, function(error) {
            ToasterService.showError($translate.instant('productimport.couldNotCheckForConnectionWithArticleData'));
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function getMissingSiblingRows() 
    {
        var request = { 
            importFileId: vm.importFile.id,
            grouping: "Color",
            rows:[] 
        };

        _.forEach(vm.importFile.importRows, function(row) {
            request.rows.push({
                barcode: row.barcode,
                salesPrice: row.salesPrice,
                purchaseCost: row.purchaseCost,
                productImportId: vm.importFile.id
            });
        });

        loadSpinnerService.start('mainSpinner');
        FileDataImportApiServiceV2.getMissingSiblingRows(request).then(function(response) {
            ToasterService.showSuccess($translate.instant('success'));
            var rows = response.data;

            _.forEach(rows, function(r) { 
                r.isAutoGeneratedSiblingRow = true;
                vm.importFile.importRows.push(r); 
            });

            refreshView();
        }, function(error) {
            ToasterService.showError($translate.instant('failure'));
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function refreshView() {
        vm.importUpdateCount++;
        resetSelectedImportRows();
    }

    function getPdfLabels() {
        loadSpinnerService.start('mainSpinner');
        FileDataImportApiServiceV2.getPdfLabels(vm.importFile.id, vm.selectedLocation.id).then(function(response) {
            ToasterService.showSuccess($translate.instant('success'));
        },function(error) {
            ToasterService.showError($translate.instant('failure'));
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });

    }

    function connectWithArticleData() {
        loadSpinnerService.start('mainSpinner', { message: $translate.instant('productimport.connectingToArticleData') });
        var request = {
            importFileId: vm.importFile.id
        };
        FileDataImportApiServiceV2.connectWithArticleData(request).then(function(response) {
            ToasterService.showSuccess($translate.instant('productimport.connectWithArticleDataSuccessful'));
            $state.reload();
        }, function(error) {
            ToasterService.showError($translate.instant('productimport.couldNotConnectWithArticleData'));
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function disableAutoArticleData(){
        loadSpinnerService.start('mainSpinner');
        var request = {
            importFileId: vm.importFile.id
        };
        FileDataImportApiServiceV2.disableAutoArticleData(request).then(function(response) {
            $state.reload();
        }, function(error) {
            ToasterService.showError($translate.instant('common.error'));
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function selectFileRows(fileRows, displayMessage) {
        vm.selectedFileRowIds = [];
        vm.selectedDisplayMessage = displayMessage;
        _.forEach(fileRows, function(fileRow) {
            vm.selectedFileRowIds.push(fileRow.id);
        });
    }

    function resetSelectedImportRows() {
        vm.selectedFileRowIds = [];
        vm.selectedDisplayMessage = '';
    }

    function isAllowedToFinalize() {
        // Find errors that is severe enough that the file cannot be finalized.
        var isAllowedToFinalize = true;
        var criticalErrors = getCriticalErrors();

        if (criticalErrors.length !== 0) {
            isAllowedToFinalize = false;
        }
        return isAllowedToFinalize;
    }

    function isAllowedToSave() {
        return true;
    }

    function saveImportFile() {
        var fileRowsToSave = [];

        _.forEach(vm.importFile.importRows, function(row) {
            if (!row.isPristine) {
                fileRowsToSave.push(row);
                row.productImportId = vm.importFile.id;
            }
        });

        loadSpinnerService.start('mainSpinner');
        FileDataImportApiServiceV2.updateFileRows(fileRowsToSave).then(function(response) {
            _.forEach(response, function(r) {
                var localRow = _.find(vm.importFile.importRows, function(row) { return row.id === r.id; });
                localRow.isPristine = true;
            });

            if (response.length === 0) {
                ToasterService.showWarning($translate.instant('productimport.noChangesToSave'));
            } else {
                validateImportFileWithId(vm.importFile.id);
            }
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function validateImportFileWithId(importFileId) {
        loadSpinnerService.start('mainSpinner', { message: $translate.instant('productimport.loadingValidatingImportRows') });
        var promises = [];

        var promise = FileDataImportApiServiceV2.validateImportFileWithId(importFileId);
        promises.push(promise);

        promise = FileDataImportApiServiceV2.checkImportFileDataExistence(importFileId);
        promises.push(promise);

        $q.all(promises).then(function(responses) {
            vm.validationErrors = [];
            handleValidationErrors(responses[0]);

            vm.dataCheckResults = [];
            _.forEach(responses[1], function(res) {
                vm.dataCheckResults.push(res);
            });

            vm.validationErrorChangeCount++;
        }, function(error) {
            ToasterService.showError($translate.instant('productimport.couldntValidateFile'), 
                                            $translate.instant('inventory.error') + ':', 15000);
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function handleValidationErrors(validationResults) {
        vm.validationErrors = [];
        _.forEach(validationResults, function(res) {
            var fileRow = res.importRow;
            var newValidationErrors = res.validationErrors;
            _.forEach(newValidationErrors, function(validationError) {
                var validationErrorRow = _.find(vm.validationErrors, function(err) { return err.displayMessage === validationError.displayMessage; });
                if (validationErrorRow === undefined) {
                    validationErrorRow = validationError;
                    validationErrorRow['fileRows'] = [];
                    vm.validationErrors.push(validationErrorRow);
                }

                if (!_.find(validationErrorRow.fileRows, function(fr) { return fr.id === fileRow.id; })) {
                    validationErrorRow.fileRows.push(fileRow);
                }
            });
        });
    }

    function shouldShowValidationErrorsPanel() {
        var showErrorsPanel = false;
        var criticalErrors = getCriticalErrors();
        var nonHiddenWarnings = _.filter(vm.validationErrors, function(validationError) {
            return validationError.severity === 'warning' && !validationError.hide;
        });

        if (nonHiddenWarnings.length + criticalErrors.length > 0) {
            showErrorsPanel = true;
        }
        return showErrorsPanel;
    }

    function showFinalizeDialog() {
        if (vm.hasAdvancedImportModule) {
            loadSpinnerService.start('mainSpinner', { message: $translate.instant('productimport.verifying') });
            FileDataImportApiServiceV2.existsSiblingPrices(vm.importFile.id).then(function(response) {
                if (response.data === true) {
                    importFinalizationDialogService.showDialog().then(function(dialogResponse) {
                        finalizeImportFile(dialogResponse);
                    });
                } else {
                    finalizeImportFile();
                }
            }).finally(function() { loadSpinnerService.stop('mainSpinner'); });
        } else {
            finalizeImportFile();
        }
    }

    function finalizeImportFile(priceUpdateGroupingLevel) {
        var shouldPromptMultipleBarcodeGenDialog = vm.validationErrors.find(function(item){
            return item.displayMessage === 'productimport.foundProductButBarcodeDoesNotMatch'
        })

        if(shouldPromptMultipleBarcodeGenDialog){
            confirmationDialogService.showDialog($translate.instant("productimport.foundProductButBarcodeDoesNotMatchDialogMessage"), 'warning').then(function (result) {
                if (result === true) {
                    doFinalizeImport(priceUpdateGroupingLevel);
                }
            });
        }
        else{
            doFinalizeImport(priceUpdateGroupingLevel);
        }
    }

    function doFinalizeImport(priceUpdateGroupingLevel){
        loadSpinnerService.start('mainSpinner', { message: $translate.instant('productimport.finalizingImport') });
        FileDataImportApiServiceV2.finalizeImport(vm.importFile.id, priceUpdateGroupingLevel).then(function(response) {
            ToasterService.showSuccess($translate.instant('productimport.finalizationSuccessful'));
            $state.go('product.productimport');
        }, function(error) {
            ToasterService.showError(error.message, $translate.instant('inventory.error') + ':', 15000);
            ToasterService.showError($translate.instant('productimport.couldNotFinalizeImport'), $translate.instant('inventory.error') + ':', 15000);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function getCriticalErrors() {
        var criticalErrors = _.filter(vm.validationErrors, function(validationError) {
            return (_.find(criticalSeverityLevels, function(errorType) { return validationError.severity === errorType; }) !== undefined);
        });
        return criticalErrors;
    }

    function setAllRowsPristine() {
        _.forEach(vm.importFile.importRows, function(row) {
            row.isPristine = true;
        });
    }

    function updateImportSummary() {
        vm.importUpdateCount++;
    }
}

angular
.module('product.productimporteditor', ['product.productimporteditor.connectVitalArticleInformationDialog'])
.config(stateConfig)
.controller('ProductImportEditorController', ProductImportEditorController);
